import { Chain } from '@wagmi/core/chains';

export const poaCore: Chain = {
  id: 99,
  name: 'POA Network Core',
  network: 'poa-core',
  nativeCurrency: {
    name: 'POA',
    symbol: 'POA',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://poa.arianee.net'],
    },
    public: {
      http: ['https://core.poa.network'],
    },
  },
  blockExplorers: {
    default: {
      name: 'BlockScout',
      url: 'https://blockscout.com/poa/core',
    },
  },
};

// This network is not the legacy POA Sokol that is now deprecated
// It's the fork of the POA Sokol network that is used by Arianee
export const poaSokolArianee: Chain = {
  id: 77,
  name: 'POA Network Sokol',
  network: 'poa-sokol',
  nativeCurrency: {
    name: 'SPOA',
    symbol: 'SPOA',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://sokol.arianee.net'],
    },
    public: {
      http: ['https://sokol.arianee.net'],
    },
  },
  blockExplorers: {
    default: {
      name: 'BlockScout',
      url: 'https://blockscout.sokol.arianee.net/',
    },
  },
};

import { mainnet as _ethereum } from '@wagmi/core/chains';
export const ethereum: Chain = {
  ..._ethereum,
  rpcUrls: {
    default: {
      http: [
        'https://eth-mainnet.g.alchemy.com/v2/JlT0yUjw9XOdevTEVDg_i_2DOjB0xvvn',
      ],
    },
    public: {
      http: [
        'https://eth-mainnet.g.alchemy.com/v2/JlT0yUjw9XOdevTEVDg_i_2DOjB0xvvn',
      ],
    },
  },
};

import { goerli as _goerli } from '@wagmi/core/chains';
export const goerli: Chain = {
  ..._goerli,
  rpcUrls: {
    default: {
      http: [
        'https://eth-goerli.g.alchemy.com/v2/LVuLnd0Gzb7qLMNfNMgbDxg1H6gnHP7p',
      ],
    },
    public: {
      http: [
        'https://eth-goerli.g.alchemy.com/v2/LVuLnd0Gzb7qLMNfNMgbDxg1H6gnHP7p',
      ],
    },
  },
};

export { sepolia } from '@wagmi/core/chains';

import { polygon as _polygon } from '@wagmi/core/chains';
export const polygon: Chain = {
  ..._polygon,
  rpcUrls: {
    default: {
      http: ['https://polygon.arianee.net'],
    },
    public: {
      http: ['https://polygon.arianee.net'],
    },
  },
};

import { polygonMumbai as _polygonMumbai } from '@wagmi/core/chains';
export const polygonMumbai: Chain = {
  ..._polygonMumbai,
  rpcUrls: {
    default: {
      http: [
        'https://polygon-mumbai.g.alchemy.com/v2/5xTwZH3byXFPQhQ173ZUqql72WGYXmFQ',
      ],
    },
    public: {
      http: [
        'https://polygon-mumbai.g.alchemy.com/v2/5xTwZH3byXFPQhQ173ZUqql72WGYXmFQ',
      ],
    },
  },
};

export { localhost } from '@wagmi/core/chains';
export { hardhat } from '@wagmi/core/chains';

export type WagmiChain = Chain;
